import { useTranslation } from 'react-i18next';

import Banner from './Banner.jsx';

const LivePrizeBanner = ({ prize }) => {
  const { t } = useTranslation('posts');
  const { remainingInfo } = prize;

  return (
    <Banner
      header={t('prizeBanner.prizeInProgress')}
      description={t('prizeBanner.prizeInProgressBody', {
        fullDate: remainingInfo.pick_winners_starting,
      })}
      errors={t('prizeBanner.errors.earlySchedule')}
    />
  );
};

export default LivePrizeBanner;
